import { apiClient } from "../../../base/ApiClient";

export const getVaccinations = async (page = 1, pagination="False") => {
  const response = await apiClient.get(`/assessments/vaccinations/?page=${page}`);
  return response.data;
};

export const getAllVaccinations = async () => {
  const response = await apiClient.get(`/assessments/vaccinations/?pagination=False`);
  return response.data;
};

export const createVaccination = async ({ name }) => {
  const response = await apiClient.post("/assessments/vaccinations/", { name });
  return response.data;
};

export const updateVaccination = async ({ id, name }) => {
  const response = await apiClient.patch(`/assessments/vaccinations/${id}/`, { name });
  return response.data;
};

export const deleteVaccination = async (id) => {
  const response = await apiClient.delete(`/assessments/vaccinations/${id}/`);
  return response.data;
};

export const getVaccinationRecords = async (page = 1) => {
  const response = await apiClient.get(`/assessments/vaccination-records/?page=${page}`);
  return response.data;
};

export const getAllVaccinationRecords = async (userType = "client") => {
  const response = await apiClient.get(
    `/assessments/vaccination-records/?user_type=${userType}&all=true`
  );
  return response.data;
};

export const createVaccinationRecord = async (payload) => {
  const response = await apiClient.post("/assessments/vaccination-records/", payload);
  return response.data;
};

export const updateVaccinationRecord = async ({ id, ...payload }) => {
  const response = await apiClient.put(`/assessments/vaccination-records/${id}/`, payload);
  return response.data;
};

export const deleteVaccinationRecord = async (id) => {
  const response = await apiClient.delete(`/assessments/vaccination-records/${id}/`);
  return response.data;
};
